import { render, staticRenderFns } from "./VocationalLarge.vue?vue&type=template&id=bc75ccd4&"
import script from "./VocationalLarge.vue?vue&type=script&lang=js&"
export * from "./VocationalLarge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports